module.exports = __webpack_public_path__ + "static/media/5DPO4.3eb91905.jpg";